module.exports = __webpack_public_path__ + "img/Customer-Visits-Visiting-Customer7.6bd93310.jpg";